interface HospitalCountResponse {
  total_num: string | number
}

interface HospitalCount {
  totalCount: number
}

export function convertHospitalCount(
  data: HospitalCountResponse
): HospitalCount {
  return {
    totalCount: Number(data.total_num) || 0
  }
}
